import React, { FunctionComponent } from 'react';

import {
  PublishingSource,
  TimelineEntry,
} from '../../../../types/__generated__';
import ShareButton from '../ShareButton/ShareButton';
import { StravaLink } from '../StravaTimelineEntry/StravaLink';

import styles from '../Timeline.scss';

interface FooterProps {
  timelineEntry: TimelineEntry;
}

export const Footer: FunctionComponent<FooterProps> = ({
  timelineEntry: { fitnessActivity, media, message, publishingSource },
}) => {
  const activityId = fitnessActivity?.activityId;

  return (
    <div className={`${styles.actionsContainer} jg-flex-jcb`}>
      <ShareButton timelineImage={media?.[0]?.url} description={message} />
      {activityId &&
        (publishingSource === PublishingSource.Strava ? (
          <StravaLink activityId={activityId} />
        ) : (
          ''
        ))}
    </div>
  );
};

Footer.displayName = 'TimelineEntryFooter';
